export const messages = {
  en_us: require("@/locale/lang/en_US.json"),
  id_id: require("@/locale/lang/id_ID.json"),
  th_th: require("@/locale/lang/th_TH.json"),
  ms_my: require("@/locale/lang/ms_MY.json"),
  es_es: require("@/locale/lang/es_ES.json"),
  zh_yd: require("@/locale/lang/te_IN.json"),
  zh_cn: require("@/locale/lang/zh_CN.json"),
  zh_hk: require("@/locale/lang/zh_HK.json"),
  vi_vn: require("@/locale/lang/vi_VN.json"),
  ja_jp: require("@/locale/lang/ja_JP.json"),
  ko_kr: require("@/locale/lang/ko_KR.json"),
};
export const lang_list = {
    id_id:'Indonesia',
    en_us:'English',
    th_th:'ภาษาไทย',
    ms_my:'Melayu',
    es_es:'español',
    zh_yd:'हिंदी',
    zh_cn:'简体中文',
    zh_hk:'繁体中文',
    vi_vn:'Tiếng Việt',
    ja_jp:'日本語',
    ko_kr:'한국어'
}
export const langDefault = () => {
  lang = "en_us"
  localStorage.setItem("lang", lang);
}
let lang = localStorage.getItem("lang");
if (!lang || !messages[lang]) {
  langDefault();
}
export { lang };
